import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

/**
 * Production-ready ProtectedRoute
 * @param {boolean} adminOnly - If true, restricts access to admin role
 * @param {React.ReactNode} children - The component to render
 */
export default function ProtectedRoute({ children, adminOnly = false }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div
        className="min-h-screen flex items-center justify-center bg-background"
        data-testid="auth-loading"
      >
        <div className="brutal p-8 bg-white font-bold text-center">
          <div className="text-xl mb-2">Loading session...</div>
          <div className="text-sm text-muted-foreground">Checking your account securely.</div>
        </div>
      </div>
    );
  }

  // 2. Unauthenticated State
  // We pass the current path into 'state' so the login page can redirect back here
  if (!user) {
    return (
      <Navigate 
        to="/login" 
        state={{ from: location }} 
        replace 
      />
    );
  }

  // 3. Admin Authorization State
  // If user is logged in but lacks the 'admin' role
  if (adminOnly && user.role !== "admin") {
    console.warn(`Access denied for user ${user.id}: Admin role required.`);
    return <Navigate to="/app" replace />;
  }

  // 4. Authorized State
  return children;
}
